export default __webpack_public_path__ + "static/media/MLM_BANNER.a094f309.png";